/** Agent referrals page — non-English overrides */
export const panelAgentReferralsByLang = {
  es: {
    'agent.referrals.rankExplainer':
      'Solo cuentan los usuarios referidos (no agentes patrocinados). Cada uno debe alcanzar el depósito mínimo de ese nivel para contar en tu rango.',
    'agent.referrals.currentRank.minDeposit': '· {{amount}} depósito mín.',
    'agent.referrals.rankingFootnote':
      'Depósito mín. = depósitos completados que debe tener cada usuario referido para ese nivel. La recompensa se acredita cuando se cumplen ambos requisitos de referidos.',
    'agent.referrals.tabDirect': 'Referidos directos ({{count}})',
    'agent.referrals.tabIndirect': 'Referidos indirectos ({{count}})',
    'agent.referrals.tabLeaderboard': 'Clasificación',
    'agent.referrals.tabLeaderboardCount': 'Clasificación ({{count}})',
    'agent.referrals.link.title': 'Tu enlace de referido de agente',
    'agent.referrals.link.loading': 'Cargando enlace de referido...',
    'agent.referrals.link.share': 'Compartir',
    'agent.referrals.link.shareTitle': 'Únete a MineMe',
    'agent.referrals.link.shareText': 'Regístrate con mi enlace de referido de agente',
    'agent.referrals.link.toastUnavailable': 'El enlace de referido aún no está disponible',
    'agent.referrals.link.toastCopied': 'Enlace copiado al portapapeles',
    'agent.referrals.link.toastCopyFailed': 'No se pudo copiar el enlace',
    'agent.referrals.link.scheduleInstant': 'La comisión se acredita y puede retirarse al instante.',
    'agent.referrals.link.scheduleAfterOne': 'La comisión se acredita y puede retirarse después de 1 día.',
    'agent.referrals.link.scheduleAfterMany': 'La comisión se acredita y puede retirarse después de {{days}} días.',
    'agent.referrals.link.earningsWithIndirect': 'Ganas {{directPct}} de comisión en todas sus inversiones y {{indirectPct}} en las inversiones de sus referidos.',
    'agent.referrals.link.earningsDirectOnly': 'Ganas {{directPct}} de comisión en todas sus inversiones.',
    'agent.referrals.link.intro': 'Cada usuario que se registre con tu enlace será tu referido directo. {{earnings}}{{schedule}}',
    'agent.referrals.stats.directLabel': 'Referidos directos',
    'agent.referrals.stats.indirectLabel': 'Referidos indirectos',
    'agent.referrals.stats.conversionLabel': 'Tasa de conversión',
    'agent.referrals.stats.conversionHint': 'Activo = estado de la cuenta (no si invirtió)',
    'agent.referrals.stats.activeTotal': '{{active}} activos / {{total}} total',
    'agent.referrals.stats.loading': 'Cargando…',
    'agent.referrals.stats.loadingBadge': 'Cargando…',
    'agent.referrals.stats.noTiers': 'No hay niveles de rango cargados — revisa los niveles en el admin.',
    'agent.referrals.stats.allTargetsMet': 'Todos los objetivos de nivel configurados cumplidos',
    'agent.referrals.stats.directTargetsNotSet': 'Los objetivos de referidos directos no están configurados en los niveles (admin).',
    'agent.referrals.stats.indirectTargetsNotSet': 'Los objetivos de referidos indirectos no están configurados en los niveles (admin).',
    'agent.referrals.stats.directMetForTier': 'Requisito directo cumplido para {{tier}}',
    'agent.referrals.stats.directMoreToReach': '{{remaining}} más para alcanzar {{tier}} ({{target}})',
    'agent.referrals.stats.indirectMetForTier': 'Requisito indirecto cumplido para {{tier}}',
    'agent.referrals.stats.indirectMoreToReach': '{{remaining}} más para alcanzar {{tier}} ({{target}})',
    'agent.referrals.stats.nextTierDefault': 'siguiente nivel',
    'agent.referrals.filter.all': 'Todos',
    'agent.referrals.filter.active': 'Activos',
    'agent.referrals.filter.suspended': 'Suspendidos',
    'agent.referrals.table.directTitle': 'Referidos directos',
    'agent.referrals.table.indirectTitle': 'Referidos indirectos',
    'agent.referrals.table.indirectSubtitle': 'Equipo de segundo nivel',
    'agent.referrals.table.searchPlaceholder': 'Buscar por usuario o correo',
    'agent.referrals.table.col.userId': 'ID de usuario',
    'agent.referrals.table.col.type': 'Tipo',
    'agent.referrals.table.col.name': 'Nombre',
    'agent.referrals.table.col.email': 'Correo',
    'agent.referrals.table.col.joined': 'Fecha de registro',
    'agent.referrals.table.col.status': 'Estado',
    'agent.referrals.table.col.deposited': 'Depositado',
    'agent.referrals.table.col.countsTowardRank': 'Cuenta',
    'agent.referrals.table.countsYes': 'Sí',
    'agent.referrals.table.countsNo': 'No',
    'user.referral.ranking.col.minDeposit': 'Depósito mín.',
    'agent.referrals.table.col.referredVia': 'Referido vía',
    'agent.referrals.table.loadingDirect': 'Cargando referidos directos...',
    'agent.referrals.table.loadingIndirect': 'Cargando referidos indirectos...',
    'agent.referrals.table.emptyDirect': 'No se encontraron referidos directos.',
    'agent.referrals.table.emptyIndirect': 'No se encontraron referidos indirectos.',
    'agent.referrals.table.showingDirect': 'Mostrando {{count}} referidos directos',
    'agent.referrals.table.showingIndirect': 'Mostrando {{count}} referidos indirectos',
    'agent.referrals.table.status.active': 'Activo',
    'agent.referrals.table.status.suspended': 'Suspendido',
    'agent.referrals.table.memberType.agent': 'Agente',
    'agent.referrals.table.memberType.user': 'Usuario',
    'agent.referrals.table.via': 'vía @{{username}}',
    'agent.referrals.leaderboard.title': 'Mayores ganadores',
    'agent.referrals.leaderboard.subtitle': 'Por comisión de por vida · top {{limit}}',
    'agent.referrals.leaderboard.col.position': '#',
    'agent.referrals.leaderboard.col.agent': 'Agente',
    'agent.referrals.leaderboard.col.rank': 'Rango',
    'agent.referrals.leaderboard.col.team': 'Equipo',
    'agent.referrals.leaderboard.col.earned': 'Ganado',
    'agent.referrals.leaderboard.loading': 'Cargando clasificación…',
    'agent.referrals.leaderboard.error': 'No se pudo cargar la clasificación en este momento.',
    'agent.referrals.leaderboard.empty': 'Aún no hay agentes activos — invita tu primer referido para entrar al ranking.',
    'agent.referrals.leaderboard.yourPosition': 'Tu posición',
    'agent.referrals.leaderboard.badgeYou': 'Tú',
    'agent.referrals.leaderboard.lifetimeEarnings': 'Ganancias de por vida',
    'agent.referrals.leaderboard.teamCounts': '{{direct}} directos · {{indirect}} indirectos',
    'agent.referrals.leaderboard.rank.topRank': 'Rango máximo',
    'agent.referrals.leaderboard.rank.rewardEarned': 'Recompensa obtenida',
    'agent.referrals.leaderboard.rank.workingToward': 'En camino a',
    'agent.referrals.leaderboard.rank.unranked': 'Sin rango',
    'agent.referrals.leaderboard.fallbackName': 'Agente',
  },
  de: {
    'agent.referrals.rankExplainer':
      'Nur geworbene Nutzer zählen (keine gesponserten Agenten). Jeder muss die Mindesteinzahlung dieser Stufe erreichen, um für deinen Rang zu zählen.',
    'agent.referrals.currentRank.minDeposit': '· {{amount}} Mindesteinzahlung',
    'agent.referrals.rankingFootnote':
      'Mindesteinzahlung = abgeschlossene Einzahlungen jedes geworbenen Nutzers für diese Stufe. Stufenprämie bei Erfüllung beider Referral-Anforderungen.',
    'agent.referrals.tabDirect': 'Direkte Empfehlungen ({{count}})',
    'agent.referrals.tabIndirect': 'Indirekte Empfehlungen ({{count}})',
    'agent.referrals.tabLeaderboard': 'Bestenliste',
    'agent.referrals.tabLeaderboardCount': 'Bestenliste ({{count}})',
    'agent.referrals.link.title': 'Ihr Agenten-Empfehlungslink',
    'agent.referrals.link.loading': 'Empfehlungslink wird geladen...',
    'agent.referrals.link.share': 'Teilen',
    'agent.referrals.link.shareTitle': 'MineMe beitreten',
    'agent.referrals.link.shareText': 'Mit meinem Agenten-Empfehlungslink registrieren',
    'agent.referrals.link.toastUnavailable': 'Empfehlungslink ist noch nicht verfügbar',
    'agent.referrals.link.toastCopied': 'Link in die Zwischenablage kopiert',
    'agent.referrals.link.toastCopyFailed': 'Link konnte nicht kopiert werden',
    'agent.referrals.link.scheduleInstant': 'Provision wird sofort gutgeschrieben und ist auszahlbar.',
    'agent.referrals.link.scheduleAfterOne': 'Provision wird nach 1 Tag gutgeschrieben und ist auszahlbar.',
    'agent.referrals.link.scheduleAfterMany': 'Provision wird nach {{days}} Tagen gutgeschrieben und ist auszahlbar.',
    'agent.referrals.link.earningsWithIndirect': 'Sie erhalten {{directPct}} Provision auf alle ihre Investitionen und {{indirectPct}} auf Investitionen ihrer Empfehlungen.',
    'agent.referrals.link.earningsDirectOnly': 'Sie erhalten {{directPct}} Provision auf alle ihre Investitionen.',
    'agent.referrals.link.intro': 'Jeder Nutzer, der sich über Ihren Link registriert, wird Ihre direkte Empfehlung. {{earnings}}{{schedule}}',
    'agent.referrals.stats.directLabel': 'Direkte Empfehlungen',
    'agent.referrals.stats.indirectLabel': 'Indirekte Empfehlungen',
    'agent.referrals.stats.conversionLabel': 'Conversion-Rate',
    'agent.referrals.stats.conversionHint': 'Aktiv = Kontostatus (nicht ob investiert wurde)',
    'agent.referrals.stats.activeTotal': '{{active}} aktiv / {{total}} gesamt',
    'agent.referrals.stats.loading': 'Laden…',
    'agent.referrals.stats.loadingBadge': 'Loading...',
    'agent.referrals.stats.noTiers': 'Keine Rangstufen geladen — Admin-Empfehlungsrangstufen prüfen.',
    'agent.referrals.stats.allTargetsMet': 'Alle konfigurierten Stufenziele erreicht',
    'agent.referrals.stats.directTargetsNotSet': 'Direkte Empfehlungsziele sind in den Rangstufen nicht gesetzt (Admin).',
    'agent.referrals.stats.indirectTargetsNotSet': 'Indirekte Empfehlungsziele sind in den Rangstufen nicht gesetzt (Admin).',
    'agent.referrals.stats.directMetForTier': 'Direktanforderung erfüllt für {{tier}}',
    'agent.referrals.stats.directMoreToReach': 'Noch {{remaining}} bis {{tier}} ({{target}})',
    'agent.referrals.stats.indirectMetForTier': 'Indirektanforderung erfüllt für {{tier}}',
    'agent.referrals.stats.indirectMoreToReach': 'Noch {{remaining}} bis {{tier}} ({{target}})',
    'agent.referrals.stats.nextTierDefault': 'nächste Stufe',
    'agent.referrals.filter.all': 'Alle',
    'agent.referrals.filter.active': 'Active',
    'agent.referrals.filter.suspended': 'Gesperrt',
    'agent.referrals.table.directTitle': 'Direkte Empfehlungen',
    'agent.referrals.table.indirectTitle': 'Indirekte Empfehlungen',
    'agent.referrals.table.indirectSubtitle': 'Team der zweiten Ebene',
    'agent.referrals.table.searchPlaceholder': 'Nach Benutzername oder E-Mail suchen',
    'agent.referrals.table.col.userId': 'Benutzer-ID',
    'agent.referrals.table.col.type': 'Type',
    'agent.referrals.table.col.name': 'Name',
    'agent.referrals.table.col.email': 'Email',
    'agent.referrals.table.col.joined': 'Beitrittsdatum',
    'agent.referrals.table.col.status': 'Status',
    'agent.referrals.table.col.deposited': 'Eingezahlt',
    'agent.referrals.table.col.countsTowardRank': 'Zählt',
    'agent.referrals.table.countsYes': 'Ja',
    'agent.referrals.table.countsNo': 'Nein',
    'user.referral.ranking.col.minDeposit': 'Mindesteinzahlung',
    'agent.referrals.table.col.referredVia': 'Empfohlen über',
    'agent.referrals.table.loadingDirect': 'Direkte Empfehlungen werden geladen...',
    'agent.referrals.table.loadingIndirect': 'Indirekte Empfehlungen werden geladen...',
    'agent.referrals.table.emptyDirect': 'Keine direkten Empfehlungen gefunden.',
    'agent.referrals.table.emptyIndirect': 'Keine indirekten Empfehlungen gefunden.',
    'agent.referrals.table.showingDirect': '{{count}} direkte Empfehlungen angezeigt',
    'agent.referrals.table.showingIndirect': '{{count}} indirekte Empfehlungen angezeigt',
    'agent.referrals.table.status.active': 'Active',
    'agent.referrals.table.status.suspended': 'Gesperrt',
    'agent.referrals.table.memberType.agent': 'Agent',
    'agent.referrals.table.memberType.user': 'Nutzer',
    'agent.referrals.table.via': 'über @{{username}}',
    'agent.referrals.leaderboard.title': 'Top-Verdiener',
    'agent.referrals.leaderboard.subtitle': 'Nach lebenslanger Provision · Top {{limit}}',
    'agent.referrals.leaderboard.col.position': '#',
    'agent.referrals.leaderboard.col.agent': 'Agent',
    'agent.referrals.leaderboard.col.rank': 'Rank',
    'agent.referrals.leaderboard.col.team': 'Team',
    'agent.referrals.leaderboard.col.earned': 'Verdient',
    'agent.referrals.leaderboard.loading': 'Bestenliste wird geladen…',
    'agent.referrals.leaderboard.error': 'Bestenliste konnte gerade nicht geladen werden.',
    'agent.referrals.leaderboard.empty': 'Noch keine aktiven Agenten — werben Sie Ihre erste Empfehlung an.',
    'agent.referrals.leaderboard.yourPosition': 'Ihre Position',
    'agent.referrals.leaderboard.badgeYou': 'Sie',
    'agent.referrals.leaderboard.lifetimeEarnings': 'Lebenslange Einnahmen',
    'agent.referrals.leaderboard.teamCounts': '{{direct}} direkt · {{indirect}} indirekt',
    'agent.referrals.leaderboard.rank.topRank': 'Höchster Rang',
    'agent.referrals.leaderboard.rank.rewardEarned': 'Prämie erhalten',
    'agent.referrals.leaderboard.rank.workingToward': 'Auf dem Weg zu',
    'agent.referrals.leaderboard.rank.unranked': 'Ohne Rang',
    'agent.referrals.leaderboard.fallbackName': 'Agent',
  },
  fr: {
    'agent.referrals.rankExplainer':
      'Seuls les utilisateurs parrainés comptent (pas les agents sponsorisés). Chacun doit atteindre le dépôt minimum du palier pour compter dans votre rang.',
    'agent.referrals.currentRank.minDeposit': '· {{amount}} dépôt min.',
    'agent.referrals.rankingFootnote':
      'Dépôt min. = dépôts complétés requis de chaque filleul pour ce palier. Récompense créditée lorsque les deux exigences de parrainage sont remplies.',
    'agent.referrals.tabDirect': 'Parrainages directs ({{count}})',
    'agent.referrals.tabIndirect': 'Parrainages indirects ({{count}})',
    'agent.referrals.tabLeaderboard': 'Classement',
    'agent.referrals.tabLeaderboardCount': 'Classement ({{count}})',
    'agent.referrals.link.title': 'Votre lien de parrainage agent',
    'agent.referrals.link.loading': 'Chargement du lien…',
    'agent.referrals.link.share': 'Partager',
    'agent.referrals.link.shareTitle': 'Rejoindre MineMe',
    'agent.referrals.link.shareText': 'Inscrivez-vous avec mon lien de parrainage agent',
    'agent.referrals.link.toastUnavailable': 'Le lien de parrainage n\'est pas encore disponible',
    'agent.referrals.link.toastCopied': 'Lien copié dans le presse-papiers',
    'agent.referrals.link.toastCopyFailed': 'Impossible de copier le lien',
    'agent.referrals.link.scheduleInstant': 'La commission est créditée et retirable instantanément.',
    'agent.referrals.link.scheduleAfterOne': 'La commission est créditée et retirable après 1 jour.',
    'agent.referrals.link.scheduleAfterMany': 'La commission est créditée et retirable après {{days}} jours.',
    'agent.referrals.link.earningsWithIndirect': 'Vous gagnez {{directPct}} de commission sur tous leurs investissements et {{indirectPct}} sur les investissements de leurs filleuls.',
    'agent.referrals.link.earningsDirectOnly': 'Vous gagnez {{directPct}} de commission sur tous leurs investissements.',
    'agent.referrals.link.intro': 'Chaque utilisateur inscrit via votre lien devient votre parrainage direct. {{earnings}}{{schedule}}',
    'agent.referrals.stats.directLabel': 'Parrainages directs',
    'agent.referrals.stats.indirectLabel': 'Parrainages indirects',
    'agent.referrals.stats.conversionLabel': 'Taux de conversion',
    'agent.referrals.stats.conversionHint': 'Actif = statut du compte (pas si investi)',
    'agent.referrals.stats.activeTotal': '{{active}} actifs / {{total}} au total',
    'agent.referrals.stats.loading': 'Chargement…',
    'agent.referrals.stats.loadingBadge': 'Chargement…',
    'agent.referrals.stats.noTiers': 'Aucun palier de rang chargé — vérifiez les paliers admin.',
    'agent.referrals.stats.allTargetsMet': 'Tous les objectifs de palier configurés sont atteints',
    'agent.referrals.stats.directTargetsNotSet': 'Les objectifs de parrainages directs ne sont pas définis sur les paliers (admin).',
    'agent.referrals.stats.indirectTargetsNotSet': 'Les objectifs de parrainages indirects ne sont pas définis sur les paliers (admin).',
    'agent.referrals.stats.directMetForTier': 'Exigence directe remplie pour {{tier}}',
    'agent.referrals.stats.directMoreToReach': 'Encore {{remaining}} pour atteindre {{tier}} ({{target}})',
    'agent.referrals.stats.indirectMetForTier': 'Exigence indirecte remplie pour {{tier}}',
    'agent.referrals.stats.indirectMoreToReach': 'Encore {{remaining}} pour atteindre {{tier}} ({{target}})',
    'agent.referrals.stats.nextTierDefault': 'palier suivant',
    'agent.referrals.filter.all': 'Tous',
    'agent.referrals.filter.active': 'Actifs',
    'agent.referrals.filter.suspended': 'Suspendus',
    'agent.referrals.table.directTitle': 'Parrainages directs',
    'agent.referrals.table.indirectTitle': 'Parrainages indirects',
    'agent.referrals.table.indirectSubtitle': 'Équipe de second niveau',
    'agent.referrals.table.searchPlaceholder': 'Rechercher par nom d\'utilisateur ou e-mail',
    'agent.referrals.table.col.userId': 'ID utilisateur',
    'agent.referrals.table.col.type': 'Type',
    'agent.referrals.table.col.name': 'Nom',
    'agent.referrals.table.col.email': 'E-mail',
    'agent.referrals.table.col.joined': 'Date d\'inscription',
    'agent.referrals.table.col.status': 'Statut',
    'agent.referrals.table.col.deposited': 'Déposé',
    'agent.referrals.table.col.countsTowardRank': 'Compte',
    'agent.referrals.table.countsYes': 'Oui',
    'agent.referrals.table.countsNo': 'Non',
    'user.referral.ranking.col.minDeposit': 'Dépôt min.',
    'agent.referrals.table.col.referredVia': 'Parrainé via',
    'agent.referrals.table.loadingDirect': 'Chargement des parrainages directs…',
    'agent.referrals.table.loadingIndirect': 'Chargement des parrainages indirects…',
    'agent.referrals.table.emptyDirect': 'Aucun parrainage direct trouvé.',
    'agent.referrals.table.emptyIndirect': 'Aucun parrainage indirect trouvé.',
    'agent.referrals.table.showingDirect': '{{count}} parrainages directs affichés',
    'agent.referrals.table.showingIndirect': '{{count}} parrainages indirects affichés',
    'agent.referrals.table.status.active': 'Actif',
    'agent.referrals.table.status.suspended': 'Suspendu',
    'agent.referrals.table.memberType.agent': 'Agent',
    'agent.referrals.table.memberType.user': 'Utilisateur',
    'agent.referrals.table.via': 'via @{{username}}',
    'agent.referrals.leaderboard.title': 'Meilleurs gains',
    'agent.referrals.leaderboard.subtitle': 'Par commission à vie · top {{limit}}',
    'agent.referrals.leaderboard.col.position': '#',
    'agent.referrals.leaderboard.col.agent': 'Agent',
    'agent.referrals.leaderboard.col.rank': 'Rang',
    'agent.referrals.leaderboard.col.team': 'Équipe',
    'agent.referrals.leaderboard.col.earned': 'Gagné',
    'agent.referrals.leaderboard.loading': 'Chargement du classement…',
    'agent.referrals.leaderboard.error': 'Impossible de charger le classement pour le moment.',
    'agent.referrals.leaderboard.empty': 'Aucun agent actif — parrainez votre premier filleul pour entrer au classement.',
    'agent.referrals.leaderboard.yourPosition': 'Votre position',
    'agent.referrals.leaderboard.badgeYou': 'Vous',
    'agent.referrals.leaderboard.lifetimeEarnings': 'Gains à vie',
    'agent.referrals.leaderboard.teamCounts': '{{direct}} directs · {{indirect}} indirects',
    'agent.referrals.leaderboard.rank.topRank': 'Rang maximal',
    'agent.referrals.leaderboard.rank.rewardEarned': 'Récompense obtenue',
    'agent.referrals.leaderboard.rank.workingToward': 'En route vers',
    'agent.referrals.leaderboard.rank.unranked': 'Sans rang',
    'agent.referrals.leaderboard.fallbackName': 'Agent',
  },
  ar: {
    'agent.referrals.rankExplainer':
      'يُحسب المستخدمون المُحالون فقط (وليس الوكلاء برعاية). يجب على كل منهم بلوغ الحد الأدنى للإيداع لهذا المستوى.',
    'agent.referrals.currentRank.minDeposit': '· {{amount}} حد إيداع أدنى',
    'agent.referrals.rankingFootnote':
      'الحد الأدنى للإيداع = إيداعات مكتملة مطلوبة من كل مستخدم مُحال. تُضاف المكافأة عند استيفاء شرطي الإحالة.',
    'agent.referrals.tabDirect': 'الإحالات المباشرة ({{count}})',
    'agent.referrals.tabIndirect': 'الإحالات غير المباشرة ({{count}})',
    'agent.referrals.tabLeaderboard': 'لوحة المتصدرين',
    'agent.referrals.tabLeaderboardCount': 'لوحة المتصدرين ({{count}})',
    'agent.referrals.link.title': 'رابط الإحالة الخاص بك',
    'agent.referrals.link.loading': 'جاري تحميل الرابط…',
    'agent.referrals.link.share': 'مشاركة',
    'agent.referrals.link.shareTitle': 'انضم إلى MineMe',
    'agent.referrals.link.shareText': 'سجّل عبر رابط إحالة الوكيل الخاص بي',
    'agent.referrals.link.toastUnavailable': 'رابط الإحالة غير متاح بعد',
    'agent.referrals.link.toastCopied': 'تم نسخ الرابط',
    'agent.referrals.link.toastCopyFailed': 'تعذّر نسخ الرابط',
    'agent.referrals.link.scheduleInstant': 'تُضاف العمولة ويمكن سحبها فوراً.',
    'agent.referrals.link.scheduleAfterOne': 'تُضاف العمولة ويمكن سحبها بعد يوم واحد.',
    'agent.referrals.link.scheduleAfterMany': 'تُضاف العمولة ويمكن سحبها بعد {{days}} يوماً.',
    'agent.referrals.link.earningsWithIndirect': 'تحصل على عمولة {{directPct}} على جميع استثماراتهم، و{{indirectPct}} على استثمارات إحالاتهم.',
    'agent.referrals.link.earningsDirectOnly': 'تحصل على عمولة {{directPct}} على جميع استثماراتهم.',
    'agent.referrals.link.intro': 'كل مستخدم يسجّل عبر رابطك يصبح إحالتك المباشرة. {{earnings}}{{schedule}}',
    'agent.referrals.stats.directLabel': 'الإحالات المباشرة',
    'agent.referrals.stats.indirectLabel': 'الإحالات غير المباشرة',
    'agent.referrals.stats.conversionLabel': 'معدل التحويل',
    'agent.referrals.stats.conversionHint': 'نشط = حالة الحساب (وليس ما إذا استثمر)',
    'agent.referrals.stats.activeTotal': '{{active}} نشط / {{total}} الإجمالي',
    'agent.referrals.stats.loading': 'جاري التحميل…',
    'agent.referrals.stats.loadingBadge': 'جاري التحميل…',
    'agent.referrals.stats.noTiers': 'لم يتم تحميل مستويات الرتبة — تحقق من إعدادات المشرف.',
    'agent.referrals.stats.allTargetsMet': 'تم تحقيق جميع أهداف المستويات المُعدّة',
    'agent.referrals.stats.directTargetsNotSet': 'أهداف الإحالات المباشرة غير مُعدّة في مستويات الرتبة (المشرف).',
    'agent.referrals.stats.indirectTargetsNotSet': 'أهداف الإحالات غير المباشرة غير مُعدّة في مستويات الرتبة (المشرف).',
    'agent.referrals.stats.directMetForTier': 'تم استيفاء شرط الإحالات المباشرة لـ {{tier}}',
    'agent.referrals.stats.directMoreToReach': '{{remaining}} إضافية للوصول إلى {{tier}} ({{target}})',
    'agent.referrals.stats.indirectMetForTier': 'تم استيفاء شرط الإحالات غير المباشرة لـ {{tier}}',
    'agent.referrals.stats.indirectMoreToReach': '{{remaining}} إضافية للوصول إلى {{tier}} ({{target}})',
    'agent.referrals.stats.nextTierDefault': 'المستوى التالي',
    'agent.referrals.filter.all': 'الكل',
    'agent.referrals.filter.active': 'نشط',
    'agent.referrals.filter.suspended': 'موقوف',
    'agent.referrals.table.directTitle': 'الإحالات المباشرة',
    'agent.referrals.table.indirectTitle': 'الإحالات غير المباشرة',
    'agent.referrals.table.indirectSubtitle': 'فريق المستوى الثاني',
    'agent.referrals.table.searchPlaceholder': 'البحث باسم المستخدم أو البريد',
    'agent.referrals.table.col.userId': 'معرّف المستخدم',
    'agent.referrals.table.col.type': 'النوع',
    'agent.referrals.table.col.name': 'الاسم',
    'agent.referrals.table.col.email': 'البريد الإلكتروني',
    'agent.referrals.table.col.joined': 'تاريخ الانضمام',
    'agent.referrals.table.col.status': 'الحالة',
    'agent.referrals.table.col.deposited': 'مُودَع',
    'agent.referrals.table.col.countsTowardRank': 'يُحسب',
    'agent.referrals.table.countsYes': 'نعم',
    'agent.referrals.table.countsNo': 'لا',
    'user.referral.ranking.col.minDeposit': 'حد الإيداع الأدنى',
    'agent.referrals.table.col.referredVia': 'أُحيل عبر',
    'agent.referrals.table.loadingDirect': 'جاري تحميل الإحالات المباشرة…',
    'agent.referrals.table.loadingIndirect': 'جاري تحميل الإحالات غير المباشرة…',
    'agent.referrals.table.emptyDirect': 'لم يتم العثور على إحالات مباشرة.',
    'agent.referrals.table.emptyIndirect': 'لم يتم العثور على إحالات غير مباشرة.',
    'agent.referrals.table.showingDirect': 'عرض {{count}} إحالة مباشرة',
    'agent.referrals.table.showingIndirect': 'عرض {{count}} إحالة غير مباشرة',
    'agent.referrals.table.status.active': 'نشط',
    'agent.referrals.table.status.suspended': 'موقوف',
    'agent.referrals.table.memberType.agent': 'وكيل',
    'agent.referrals.table.memberType.user': 'مستخدم',
    'agent.referrals.table.via': 'عبر @{{username}}',
    'agent.referrals.leaderboard.title': 'أعلى المكاسب',
    'agent.referrals.leaderboard.subtitle': 'حسب عمولة مدى الحياة · أفضل {{limit}}',
    'agent.referrals.leaderboard.col.position': '#',
    'agent.referrals.leaderboard.col.agent': 'وكيل',
    'agent.referrals.leaderboard.col.rank': 'الرتبة',
    'agent.referrals.leaderboard.col.team': 'الفريق',
    'agent.referrals.leaderboard.col.earned': 'المكاسب',
    'agent.referrals.leaderboard.loading': 'جاري تحميل لوحة المتصدرين…',
    'agent.referrals.leaderboard.error': 'تعذّر تحميل لوحة المتصدرين حالياً.',
    'agent.referrals.leaderboard.empty': 'لا يوجد وكلاء نشطون بعد — ادعُ أول إحالة للظهور في اللوحة.',
    'agent.referrals.leaderboard.yourPosition': 'مركزك',
    'agent.referrals.leaderboard.badgeYou': 'أنت',
    'agent.referrals.leaderboard.lifetimeEarnings': 'أرباح مدى الحياة',
    'agent.referrals.leaderboard.teamCounts': '{{direct}} مباشر · {{indirect}} غير مباشر',
    'agent.referrals.leaderboard.rank.topRank': 'أعلى رتبة',
    'agent.referrals.leaderboard.rank.rewardEarned': 'مكافأة مُحققة',
    'agent.referrals.leaderboard.rank.workingToward': 'في الطريق إلى',
    'agent.referrals.leaderboard.rank.unranked': 'بلا رتبة',
    'agent.referrals.leaderboard.fallbackName': 'وكيل',
  },
  ja: {
    'agent.referrals.rankExplainer':
      '紹介ユーザーのみカウント（スポンサー代理店は除く）。各ユーザーはそのティアの最低入金額に達する必要があります。',
    'agent.referrals.currentRank.minDeposit': '· 最低入金 {{amount}}',
    'agent.referrals.rankingFootnote':
      '最低入金＝紹介ユーザーがそのティアで必要な完了入金。紹介条件を両方満たすとティア報酬が付与されます。',
    'agent.referrals.tabDirect': '直接紹介 ({{count}})',
    'agent.referrals.tabIndirect': '間接紹介 ({{count}})',
    'agent.referrals.tabLeaderboard': 'ランキング',
    'agent.referrals.tabLeaderboardCount': 'ランキング ({{count}})',
    'agent.referrals.link.title': 'エージェント紹介リンク',
    'agent.referrals.link.loading': 'リンクを読み込み中…',
    'agent.referrals.link.share': '共有',
    'agent.referrals.link.shareTitle': 'MineMeに参加',
    'agent.referrals.link.shareText': '私のエージェント紹介リンクで登録',
    'agent.referrals.link.toastUnavailable': '紹介リンクはまだ利用できません',
    'agent.referrals.link.toastCopied': 'リンクをコピーしました',
    'agent.referrals.link.toastCopyFailed': 'リンクをコピーできませんでした',
    'agent.referrals.link.scheduleInstant': 'コミッションは即時に付与され、すぐに出金できます。',
    'agent.referrals.link.scheduleAfterOne': 'コミッションは1日後に付与され、出金できます。',
    'agent.referrals.link.scheduleAfterMany': 'コミッションは{{days}}日後に付与され、出金できます。',
    'agent.referrals.link.earningsWithIndirect': '紹介者の全投資で{{directPct}}、その紹介者の投資で{{indirectPct}}のコミッションを獲得します。',
    'agent.referrals.link.earningsDirectOnly': '紹介者の全投資で{{directPct}}のコミッションを獲得します。',
    'agent.referrals.link.intro': 'あなたのリンクから登録したユーザーは直接紹介になります。{{earnings}}{{schedule}}',
    'agent.referrals.stats.directLabel': '直接紹介',
    'agent.referrals.stats.indirectLabel': '間接紹介',
    'agent.referrals.stats.conversionLabel': 'コンバージョン率',
    'agent.referrals.stats.conversionHint': 'アクティブ＝アカウント状態（投資の有無ではありません）',
    'agent.referrals.stats.activeTotal': 'アクティブ {{active}} / 合計 {{total}}',
    'agent.referrals.stats.loading': '読み込み中…',
    'agent.referrals.stats.loadingBadge': '読み込み中…',
    'agent.referrals.stats.noTiers': 'ランク段階が読み込まれていません — 管理画面を確認してください。',
    'agent.referrals.stats.allTargetsMet': '設定されたすべての段階目標を達成しました',
    'agent.referrals.stats.directTargetsNotSet': '直接紹介の目標がランク段階に設定されていません（管理者）。',
    'agent.referrals.stats.indirectTargetsNotSet': '間接紹介の目標がランク段階に設定されていません（管理者）。',
    'agent.referrals.stats.directMetForTier': '{{tier}}の直接要件を満たしました',
    'agent.referrals.stats.directMoreToReach': '{{tier}}まであと{{remaining}}（目標{{target}}）',
    'agent.referrals.stats.indirectMetForTier': '{{tier}}の間接要件を満たしました',
    'agent.referrals.stats.indirectMoreToReach': '{{tier}}まであと{{remaining}}（目標{{target}}）',
    'agent.referrals.stats.nextTierDefault': '次の段階',
    'agent.referrals.filter.all': 'すべて',
    'agent.referrals.filter.active': 'アクティブ',
    'agent.referrals.filter.suspended': '停止中',
    'agent.referrals.table.directTitle': '直接紹介',
    'agent.referrals.table.indirectTitle': '間接紹介',
    'agent.referrals.table.indirectSubtitle': '第2レベルのチーム',
    'agent.referrals.table.searchPlaceholder': 'ユーザー名またはメールで検索',
    'agent.referrals.table.col.userId': 'ユーザーID',
    'agent.referrals.table.col.type': '種別',
    'agent.referrals.table.col.name': '名前',
    'agent.referrals.table.col.email': 'メール',
    'agent.referrals.table.col.joined': '登録日',
    'agent.referrals.table.col.status': 'ステータス',
    'agent.referrals.table.col.deposited': '入金済み',
    'agent.referrals.table.col.countsTowardRank': 'カウント',
    'agent.referrals.table.countsYes': 'はい',
    'agent.referrals.table.countsNo': 'いいえ',
    'user.referral.ranking.col.minDeposit': '最低入金',
    'agent.referrals.table.col.referredVia': '紹介経路',
    'agent.referrals.table.loadingDirect': '直接紹介を読み込み中…',
    'agent.referrals.table.loadingIndirect': '間接紹介を読み込み中…',
    'agent.referrals.table.emptyDirect': '直接紹介が見つかりません。',
    'agent.referrals.table.emptyIndirect': '間接紹介が見つかりません。',
    'agent.referrals.table.showingDirect': '直接紹介 {{count}} 件を表示',
    'agent.referrals.table.showingIndirect': '間接紹介 {{count}} 件を表示',
    'agent.referrals.table.status.active': 'アクティブ',
    'agent.referrals.table.status.suspended': '停止中',
    'agent.referrals.table.memberType.agent': 'エージェント',
    'agent.referrals.table.memberType.user': 'ユーザー',
    'agent.referrals.table.via': '@{{username}} 経由',
    'agent.referrals.leaderboard.title': 'トップ獲得者',
    'agent.referrals.leaderboard.subtitle': '累計コミッション順 · 上位{{limit}}',
    'agent.referrals.leaderboard.col.position': '#',
    'agent.referrals.leaderboard.col.agent': 'エージェント',
    'agent.referrals.leaderboard.col.rank': 'ランク',
    'agent.referrals.leaderboard.col.team': 'チーム',
    'agent.referrals.leaderboard.col.earned': '獲得',
    'agent.referrals.leaderboard.loading': 'ランキングを読み込み中…',
    'agent.referrals.leaderboard.error': '現在ランキングを読み込めません。',
    'agent.referrals.leaderboard.empty': 'まだアクティブなエージェントがいません — 最初の紹介でランクインしましょう。',
    'agent.referrals.leaderboard.yourPosition': 'あなたの順位',
    'agent.referrals.leaderboard.badgeYou': 'あなた',
    'agent.referrals.leaderboard.lifetimeEarnings': '累計収益',
    'agent.referrals.leaderboard.teamCounts': '直接 {{direct}} · 間接 {{indirect}}',
    'agent.referrals.leaderboard.rank.topRank': '最高ランク',
    'agent.referrals.leaderboard.rank.rewardEarned': '報酬獲得済み',
    'agent.referrals.leaderboard.rank.workingToward': '目指しているランク',
    'agent.referrals.leaderboard.rank.unranked': 'ランクなし',
    'agent.referrals.leaderboard.fallbackName': 'エージェント',
  },
  ko: {
    'agent.referrals.rankExplainer':
      '추천 사용자만 집계됩니다(스폰서 에이전트 제외). 각 사용자는 해당 티어의 최소 입금액을 달성해야 합니다.',
    'agent.referrals.currentRank.minDeposit': '· 최소 입금 {{amount}}',
    'agent.referrals.rankingFootnote':
      '최소 입금 = 해당 티어에서 추천 사용자가 필요한 완료 입금. 추천 조건을 모두 충족하면 티어 보상이 지급됩니다.',
    'agent.referrals.tabDirect': '직접 추천 ({{count}})',
    'agent.referrals.tabIndirect': '간접 추천 ({{count}})',
    'agent.referrals.tabLeaderboard': '리더보드',
    'agent.referrals.tabLeaderboardCount': '리더보드 ({{count}})',
    'agent.referrals.link.title': '에이전트 추천 링크',
    'agent.referrals.link.loading': '링크 불러오는 중…',
    'agent.referrals.link.share': '공유',
    'agent.referrals.link.shareTitle': 'MineMe 가입',
    'agent.referrals.link.shareText': '내 에이전트 추천 링크로 가입하세요',
    'agent.referrals.link.toastUnavailable': '추천 링크를 아직 사용할 수 없습니다',
    'agent.referrals.link.toastCopied': '링크가 복사되었습니다',
    'agent.referrals.link.toastCopyFailed': '링크를 복사할 수 없습니다',
    'agent.referrals.link.scheduleInstant': '커미션이 즉시 적립되며 바로 출금할 수 있습니다.',
    'agent.referrals.link.scheduleAfterOne': '커미션이 1일 후 적립되며 출금할 수 있습니다.',
    'agent.referrals.link.scheduleAfterMany': '커미션이 {{days}}일 후 적립되며 출금할 수 있습니다.',
    'agent.referrals.link.earningsWithIndirect': '추천인의 모든 투자에서 {{directPct}}, 그들의 추천인 투자에서 {{indirectPct}} 커미션을 받습니다.',
    'agent.referrals.link.earningsDirectOnly': '추천인의 모든 투자에서 {{directPct}} 커미션을 받습니다.',
    'agent.referrals.link.intro': '내 링크로 가입한 모든 사용자는 직접 추천이 됩니다. {{earnings}}{{schedule}}',
    'agent.referrals.stats.directLabel': '직접 추천',
    'agent.referrals.stats.indirectLabel': '간접 추천',
    'agent.referrals.stats.conversionLabel': '전환율',
    'agent.referrals.stats.conversionHint': '활성 = 계정 상태(투자 여부 아님)',
    'agent.referrals.stats.activeTotal': '활성 {{active}} / 총 {{total}}',
    'agent.referrals.stats.loading': '불러오는 중…',
    'agent.referrals.stats.loadingBadge': '불러오는 중…',
    'agent.referrals.stats.noTiers': '등급 단계가 로드되지 않았습니다 — 관리자 설정을 확인하세요.',
    'agent.referrals.stats.allTargetsMet': '설정된 모든 단계 목표를 달성했습니다',
    'agent.referrals.stats.directTargetsNotSet': '직접 추천 목표가 등급 단계에 설정되지 않았습니다(관리자).',
    'agent.referrals.stats.indirectTargetsNotSet': '간접 추천 목표가 등급 단계에 설정되지 않았습니다(관리자).',
    'agent.referrals.stats.directMetForTier': '{{tier}} 직접 요건 충족',
    'agent.referrals.stats.directMoreToReach': '{{tier}}까지 {{remaining}}명 더 필요 (목표 {{target}})',
    'agent.referrals.stats.indirectMetForTier': '{{tier}} 간접 요건 충족',
    'agent.referrals.stats.indirectMoreToReach': '{{tier}}까지 {{remaining}}명 더 필요 (목표 {{target}})',
    'agent.referrals.stats.nextTierDefault': '다음 단계',
    'agent.referrals.filter.all': '전체',
    'agent.referrals.filter.active': '활성',
    'agent.referrals.filter.suspended': '정지',
    'agent.referrals.table.directTitle': '직접 추천',
    'agent.referrals.table.indirectTitle': '간접 추천',
    'agent.referrals.table.indirectSubtitle': '2차 팀',
    'agent.referrals.table.searchPlaceholder': '사용자명 또는 이메일로 검색',
    'agent.referrals.table.col.userId': '사용자 ID',
    'agent.referrals.table.col.type': '유형',
    'agent.referrals.table.col.name': '이름',
    'agent.referrals.table.col.email': '이메일',
    'agent.referrals.table.col.joined': '가입일',
    'agent.referrals.table.col.status': '상태',
    'agent.referrals.table.col.deposited': '입금액',
    'agent.referrals.table.col.countsTowardRank': '집계',
    'agent.referrals.table.countsYes': '예',
    'agent.referrals.table.countsNo': '아니오',
    'user.referral.ranking.col.minDeposit': '최소 입금',
    'agent.referrals.table.col.referredVia': '추천 경로',
    'agent.referrals.table.loadingDirect': '직접 추천 불러오는 중…',
    'agent.referrals.table.loadingIndirect': '간접 추천 불러오는 중…',
    'agent.referrals.table.emptyDirect': '직접 추천이 없습니다.',
    'agent.referrals.table.emptyIndirect': '간접 추천이 없습니다.',
    'agent.referrals.table.showingDirect': '직접 추천 {{count}}명 표시',
    'agent.referrals.table.showingIndirect': '간접 추천 {{count}}명 표시',
    'agent.referrals.table.status.active': '활성',
    'agent.referrals.table.status.suspended': '정지',
    'agent.referrals.table.memberType.agent': '에이전트',
    'agent.referrals.table.memberType.user': '사용자',
    'agent.referrals.table.via': '@{{username}} 경유',
    'agent.referrals.leaderboard.title': '상위 수익자',
    'agent.referrals.leaderboard.subtitle': '누적 커미션 기준 · 상위 {{limit}}',
    'agent.referrals.leaderboard.col.position': '#',
    'agent.referrals.leaderboard.col.agent': '에이전트',
    'agent.referrals.leaderboard.col.rank': '등급',
    'agent.referrals.leaderboard.col.team': '팀',
    'agent.referrals.leaderboard.col.earned': '수익',
    'agent.referrals.leaderboard.loading': '리더보드 불러오는 중…',
    'agent.referrals.leaderboard.error': '지금은 리더보드를 불러올 수 없습니다.',
    'agent.referrals.leaderboard.empty': '아직 활성 에이전트가 없습니다 — 첫 추천으로 순위에 오르세요.',
    'agent.referrals.leaderboard.yourPosition': '내 순위',
    'agent.referrals.leaderboard.badgeYou': '나',
    'agent.referrals.leaderboard.lifetimeEarnings': '누적 수익',
    'agent.referrals.leaderboard.teamCounts': '직접 {{direct}} · 간접 {{indirect}}',
    'agent.referrals.leaderboard.rank.topRank': '최고 등급',
    'agent.referrals.leaderboard.rank.rewardEarned': '보상 획득',
    'agent.referrals.leaderboard.rank.workingToward': '목표 등급',
    'agent.referrals.leaderboard.rank.unranked': '등급 없음',
    'agent.referrals.leaderboard.fallbackName': '에이전트',
  },
  'zh-CN': {
    'agent.referrals.rankExplainer':
      '仅计入选荐用户（不含赞助代理）。每位用户须达到该等级的最低入金才算入您的等级。',
    'agent.referrals.currentRank.minDeposit': '· 最低入金 {{amount}}',
    'agent.referrals.rankingFootnote':
      '最低入金＝该等级下每位被荐用户须完成的入金。满足直推与间推要求后发放等级奖励。',
    'agent.referrals.tabDirect': '直推 ({{count}})',
    'agent.referrals.tabIndirect': '间推 ({{count}})',
    'agent.referrals.tabLeaderboard': '排行榜',
    'agent.referrals.tabLeaderboardCount': '排行榜 ({{count}})',
    'agent.referrals.link.title': '您的代理推荐链接',
    'agent.referrals.link.loading': '加载推荐链接…',
    'agent.referrals.link.share': '分享',
    'agent.referrals.link.shareTitle': '加入 MineMe',
    'agent.referrals.link.shareText': '使用我的代理推荐链接注册',
    'agent.referrals.link.toastUnavailable': '推荐链接暂不可用',
    'agent.referrals.link.toastCopied': '链接已复制',
    'agent.referrals.link.toastCopyFailed': '无法复制链接',
    'agent.referrals.link.scheduleInstant': '佣金即时到账，可立即提现。',
    'agent.referrals.link.scheduleAfterOne': '佣金在 1 天后到账，可提现。',
    'agent.referrals.link.scheduleAfterMany': '佣金在 {{days}} 天后到账，可提现。',
    'agent.referrals.link.earningsWithIndirect': '您从其所有投资中获得 {{directPct}} 佣金，从其推荐人的投资中获得 {{indirectPct}}。',
    'agent.referrals.link.earningsDirectOnly': '您从其所有投资中获得 {{directPct}} 佣金。',
    'agent.referrals.link.intro': '通过您的链接注册的每位用户都是您的直推。{{earnings}}{{schedule}}',
    'agent.referrals.stats.directLabel': '直推',
    'agent.referrals.stats.indirectLabel': '间推',
    'agent.referrals.stats.conversionLabel': '转化率',
    'agent.referrals.stats.conversionHint': '活跃 = 账户状态（非是否投资）',
    'agent.referrals.stats.activeTotal': '活跃 {{active}} / 共 {{total}}',
    'agent.referrals.stats.loading': '加载中…',
    'agent.referrals.stats.loadingBadge': '加载中…',
    'agent.referrals.stats.noTiers': '未加载等级阶梯 — 请检查管理员设置。',
    'agent.referrals.stats.allTargetsMet': '已达成所有配置的等级目标',
    'agent.referrals.stats.directTargetsNotSet': '等级阶梯未设置直推目标（管理员）。',
    'agent.referrals.stats.indirectTargetsNotSet': '等级阶梯未设置间推目标（管理员）。',
    'agent.referrals.stats.directMetForTier': '已满足 {{tier}} 的直推要求',
    'agent.referrals.stats.directMoreToReach': '距 {{tier}} 还差 {{remaining}}（目标 {{target}}）',
    'agent.referrals.stats.indirectMetForTier': '已满足 {{tier}} 的间推要求',
    'agent.referrals.stats.indirectMoreToReach': '距 {{tier}} 还差 {{remaining}}（目标 {{target}}）',
    'agent.referrals.stats.nextTierDefault': '下一等级',
    'agent.referrals.filter.all': '全部',
    'agent.referrals.filter.active': '活跃',
    'agent.referrals.filter.suspended': '已暂停',
    'agent.referrals.table.directTitle': '直推',
    'agent.referrals.table.indirectTitle': '间推',
    'agent.referrals.table.indirectSubtitle': '二级团队',
    'agent.referrals.table.searchPlaceholder': '按用户名或邮箱搜索',
    'agent.referrals.table.col.userId': '用户 ID',
    'agent.referrals.table.col.type': '类型',
    'agent.referrals.table.col.name': '姓名',
    'agent.referrals.table.col.email': '邮箱',
    'agent.referrals.table.col.joined': '加入日期',
    'agent.referrals.table.col.status': '状态',
    'agent.referrals.table.col.deposited': '已入金',
    'agent.referrals.table.col.countsTowardRank': '计入',
    'agent.referrals.table.countsYes': '是',
    'agent.referrals.table.countsNo': '否',
    'user.referral.ranking.col.minDeposit': '最低入金',
    'agent.referrals.table.col.referredVia': '推荐来源',
    'agent.referrals.table.loadingDirect': '正在加载直推…',
    'agent.referrals.table.loadingIndirect': '正在加载间推…',
    'agent.referrals.table.emptyDirect': '未找到直推。',
    'agent.referrals.table.emptyIndirect': '未找到间推。',
    'agent.referrals.table.showingDirect': '显示 {{count}} 条直推',
    'agent.referrals.table.showingIndirect': '显示 {{count}} 条间推',
    'agent.referrals.table.status.active': '活跃',
    'agent.referrals.table.status.suspended': '已暂停',
    'agent.referrals.table.memberType.agent': '代理',
    'agent.referrals.table.memberType.user': '用户',
    'agent.referrals.table.via': '通过 @{{username}}',
    'agent.referrals.leaderboard.title': '收益榜',
    'agent.referrals.leaderboard.subtitle': '按累计佣金 · 前 {{limit}}',
    'agent.referrals.leaderboard.col.position': '#',
    'agent.referrals.leaderboard.col.agent': '代理',
    'agent.referrals.leaderboard.col.rank': '等级',
    'agent.referrals.leaderboard.col.team': '团队',
    'agent.referrals.leaderboard.col.earned': '收益',
    'agent.referrals.leaderboard.loading': '加载排行榜…',
    'agent.referrals.leaderboard.error': '暂时无法加载排行榜。',
    'agent.referrals.leaderboard.empty': '尚无活跃代理 — 邀请第一位推荐人上榜。',
    'agent.referrals.leaderboard.yourPosition': '您的排名',
    'agent.referrals.leaderboard.badgeYou': '您',
    'agent.referrals.leaderboard.lifetimeEarnings': '累计收益',
    'agent.referrals.leaderboard.teamCounts': '直推 {{direct}} · 间推 {{indirect}}',
    'agent.referrals.leaderboard.rank.topRank': '最高等级',
    'agent.referrals.leaderboard.rank.rewardEarned': '已获得奖励',
    'agent.referrals.leaderboard.rank.workingToward': '目标等级',
    'agent.referrals.leaderboard.rank.unranked': '未评级',
    'agent.referrals.leaderboard.fallbackName': '代理',
  },
  pt: {
    'agent.referrals.rankExplainer':
      'Contam apenas usuários indicados (não agentes patrocinados). Cada um deve atingir o depósito mínimo do nível.',
    'agent.referrals.currentRank.minDeposit': '· {{amount}} depósito mín.',
    'agent.referrals.rankingFootnote':
      'Depósito mín. = depósitos concluídos exigidos de cada indicado. Recompensa creditada quando ambos os requisitos forem cumpridos.',
    'agent.referrals.tabDirect': 'Indicações diretas ({{count}})',
    'agent.referrals.tabIndirect': 'Indicações indiretas ({{count}})',
    'agent.referrals.tabLeaderboard': 'Ranking',
    'agent.referrals.tabLeaderboardCount': 'Ranking ({{count}})',
    'agent.referrals.link.title': 'Seu link de indicação de agente',
    'agent.referrals.link.loading': 'Carregando link…',
    'agent.referrals.link.share': 'Compartilhar',
    'agent.referrals.link.shareTitle': 'Junte-se à MineMe',
    'agent.referrals.link.shareText': 'Cadastre-se com meu link de indicação de agente',
    'agent.referrals.link.toastUnavailable': 'O link de indicação ainda não está disponível',
    'agent.referrals.link.toastCopied': 'Link copiado',
    'agent.referrals.link.toastCopyFailed': 'Não foi possível copiar o link',
    'agent.referrals.link.scheduleInstant': 'A comissão é creditada e pode ser sacada instantaneamente.',
    'agent.referrals.link.scheduleAfterOne': 'A comissão é creditada e pode ser sacada após 1 dia.',
    'agent.referrals.link.scheduleAfterMany': 'A comissão é creditada e pode ser sacada após {{days}} dias.',
    'agent.referrals.link.earningsWithIndirect': 'Você ganha {{directPct}} de comissão em todos os investimentos deles e {{indirectPct}} nos investimentos das indicações deles.',
    'agent.referrals.link.earningsDirectOnly': 'Você ganha {{directPct}} de comissão em todos os investimentos deles.',
    'agent.referrals.link.intro': 'Cada usuário que se cadastrar pelo seu link será sua indicação direta. {{earnings}}{{schedule}}',
    'agent.referrals.stats.directLabel': 'Indicações diretas',
    'agent.referrals.stats.indirectLabel': 'Indicações indiretas',
    'agent.referrals.stats.conversionLabel': 'Taxa de conversão',
    'agent.referrals.stats.conversionHint': 'Ativo = status da conta (não se investiu)',
    'agent.referrals.stats.activeTotal': '{{active}} ativos / {{total}} no total',
    'agent.referrals.stats.loading': 'Carregando…',
    'agent.referrals.stats.loadingBadge': 'Carregando…',
    'agent.referrals.stats.noTiers': 'Nenhum nível de rank carregado — verifique os níveis no admin.',
    'agent.referrals.stats.allTargetsMet': 'Todas as metas de nível configuradas foram atingidas',
    'agent.referrals.stats.directTargetsNotSet': 'Metas de indicações diretas não estão definidas nos níveis (admin).',
    'agent.referrals.stats.indirectTargetsNotSet': 'Metas de indicações indiretas não estão definidas nos níveis (admin).',
    'agent.referrals.stats.directMetForTier': 'Requisito direto cumprido para {{tier}}',
    'agent.referrals.stats.directMoreToReach': 'Mais {{remaining}} para alcançar {{tier}} ({{target}})',
    'agent.referrals.stats.indirectMetForTier': 'Requisito indireto cumprido para {{tier}}',
    'agent.referrals.stats.indirectMoreToReach': 'Mais {{remaining}} para alcançar {{tier}} ({{target}})',
    'agent.referrals.stats.nextTierDefault': 'próximo nível',
    'agent.referrals.filter.all': 'Todos',
    'agent.referrals.filter.active': 'Ativos',
    'agent.referrals.filter.suspended': 'Suspensos',
    'agent.referrals.table.directTitle': 'Indicações diretas',
    'agent.referrals.table.indirectTitle': 'Indicações indiretas',
    'agent.referrals.table.indirectSubtitle': 'Equipe de segundo nível',
    'agent.referrals.table.searchPlaceholder': 'Buscar por usuário ou e-mail',
    'agent.referrals.table.col.userId': 'ID do usuário',
    'agent.referrals.table.col.type': 'Tipo',
    'agent.referrals.table.col.name': 'Nome',
    'agent.referrals.table.col.email': 'E-mail',
    'agent.referrals.table.col.joined': 'Data de cadastro',
    'agent.referrals.table.col.status': 'Status',
    'agent.referrals.table.col.deposited': 'Depositado',
    'agent.referrals.table.col.countsTowardRank': 'Conta',
    'agent.referrals.table.countsYes': 'Sim',
    'agent.referrals.table.countsNo': 'Não',
    'user.referral.ranking.col.minDeposit': 'Depósito mín.',
    'agent.referrals.table.col.referredVia': 'Indicado via',
    'agent.referrals.table.loadingDirect': 'Carregando indicações diretas…',
    'agent.referrals.table.loadingIndirect': 'Carregando indicações indiretas…',
    'agent.referrals.table.emptyDirect': 'Nenhuma indicação direta encontrada.',
    'agent.referrals.table.emptyIndirect': 'Nenhuma indicação indireta encontrada.',
    'agent.referrals.table.showingDirect': 'Mostrando {{count}} indicações diretas',
    'agent.referrals.table.showingIndirect': 'Mostrando {{count}} indicações indiretas',
    'agent.referrals.table.status.active': 'Ativo',
    'agent.referrals.table.status.suspended': 'Suspenso',
    'agent.referrals.table.memberType.agent': 'Agente',
    'agent.referrals.table.memberType.user': 'Usuário',
    'agent.referrals.table.via': 'via @{{username}}',
    'agent.referrals.leaderboard.title': 'Maiores ganhadores',
    'agent.referrals.leaderboard.subtitle': 'Por comissão vitalícia · top {{limit}}',
    'agent.referrals.leaderboard.col.position': '#',
    'agent.referrals.leaderboard.col.agent': 'Agente',
    'agent.referrals.leaderboard.col.rank': 'Rank',
    'agent.referrals.leaderboard.col.team': 'Equipe',
    'agent.referrals.leaderboard.col.earned': 'Ganhos',
    'agent.referrals.leaderboard.loading': 'Carregando ranking…',
    'agent.referrals.leaderboard.error': 'Não foi possível carregar o ranking agora.',
    'agent.referrals.leaderboard.empty': 'Ainda não há agentes ativos — indique seu primeiro referido para entrar no ranking.',
    'agent.referrals.leaderboard.yourPosition': 'Sua posição',
    'agent.referrals.leaderboard.badgeYou': 'Você',
    'agent.referrals.leaderboard.lifetimeEarnings': 'Ganhos vitalícios',
    'agent.referrals.leaderboard.teamCounts': '{{direct}} diretos · {{indirect}} indiretos',
    'agent.referrals.leaderboard.rank.topRank': 'Rank máximo',
    'agent.referrals.leaderboard.rank.rewardEarned': 'Recompensa obtida',
    'agent.referrals.leaderboard.rank.workingToward': 'Em direção a',
    'agent.referrals.leaderboard.rank.unranked': 'Sem rank',
    'agent.referrals.leaderboard.fallbackName': 'Agente',
  },
  it: {
    'agent.referrals.rankExplainer':
      'Contano solo gli utenti referral (non gli agenti sponsorizzati). Ognuno deve raggiungere il deposito minimo del livello.',
    'agent.referrals.currentRank.minDeposit': '· {{amount}} deposito min.',
    'agent.referrals.rankingFootnote':
      'Deposito min. = depositi completati richiesti per ogni referral. Ricompensa quando entrambi i requisiti sono soddisfatti.',
    'agent.referrals.tabDirect': 'Referral diretti ({{count}})',
    'agent.referrals.tabIndirect': 'Referral indiretti ({{count}})',
    'agent.referrals.tabLeaderboard': 'Classifica',
    'agent.referrals.tabLeaderboardCount': 'Classifica ({{count}})',
    'agent.referrals.link.title': 'Il tuo link referral agente',
    'agent.referrals.link.loading': 'Caricamento link…',
    'agent.referrals.link.share': 'Condividi',
    'agent.referrals.link.shareTitle': 'Unisciti a MineMe',
    'agent.referrals.link.shareText': 'Registrati con il mio link referral agente',
    'agent.referrals.link.toastUnavailable': 'Il link referral non è ancora disponibile',
    'agent.referrals.link.toastCopied': 'Link copiato',
    'agent.referrals.link.toastCopyFailed': 'Impossibile copiare il link',
    'agent.referrals.link.scheduleInstant': 'La commissione è accreditata e prelevabile subito.',
    'agent.referrals.link.scheduleAfterOne': 'La commissione è accreditata e prelevabile dopo 1 giorno.',
    'agent.referrals.link.scheduleAfterMany': 'La commissione è accreditata e prelevabile dopo {{days}} giorni.',
    'agent.referrals.link.earningsWithIndirect': 'Guadagni {{directPct}} di commissione su tutti i loro investimenti e {{indirectPct}} su quelli dei loro referral.',
    'agent.referrals.link.earningsDirectOnly': 'Guadagni {{directPct}} di commissione su tutti i loro investimenti.',
    'agent.referrals.link.intro': 'Ogni utente che si registra con il tuo link diventa tuo referral diretto. {{earnings}}{{schedule}}',
    'agent.referrals.stats.directLabel': 'Referral diretti',
    'agent.referrals.stats.indirectLabel': 'Referral indiretti',
    'agent.referrals.stats.conversionLabel': 'Tasso di conversione',
    'agent.referrals.stats.conversionHint': 'Attivo = stato account (non se ha investito)',
    'agent.referrals.stats.activeTotal': '{{active}} attivi / {{total}} totali',
    'agent.referrals.stats.loading': 'Caricamento…',
    'agent.referrals.stats.loadingBadge': 'Caricamento…',
    'agent.referrals.stats.noTiers': 'Nessun livello rank caricato — controlla i livelli admin.',
    'agent.referrals.stats.allTargetsMet': 'Tutti gli obiettivi di livello configurati sono stati raggiunti',
    'agent.referrals.stats.directTargetsNotSet': 'Obiettivi referral diretti non impostati sui livelli (admin).',
    'agent.referrals.stats.indirectTargetsNotSet': 'Obiettivi referral indiretti non impostati sui livelli (admin).',
    'agent.referrals.stats.directMetForTier': 'Requisito diretto soddisfatto per {{tier}}',
    'agent.referrals.stats.directMoreToReach': 'Ancora {{remaining}} per raggiungere {{tier}} ({{target}})',
    'agent.referrals.stats.indirectMetForTier': 'Requisito indiretto soddisfatto per {{tier}}',
    'agent.referrals.stats.indirectMoreToReach': 'Ancora {{remaining}} per raggiungere {{tier}} ({{target}})',
    'agent.referrals.stats.nextTierDefault': 'livello successivo',
    'agent.referrals.filter.all': 'Tutti',
    'agent.referrals.filter.active': 'Attivi',
    'agent.referrals.filter.suspended': 'Sospesi',
    'agent.referrals.table.directTitle': 'Referral diretti',
    'agent.referrals.table.indirectTitle': 'Referral indiretti',
    'agent.referrals.table.indirectSubtitle': 'Team di secondo livello',
    'agent.referrals.table.searchPlaceholder': 'Cerca per username o email',
    'agent.referrals.table.col.userId': 'ID utente',
    'agent.referrals.table.col.type': 'Tipo',
    'agent.referrals.table.col.name': 'Nome',
    'agent.referrals.table.col.email': 'Email',
    'agent.referrals.table.col.joined': 'Data iscrizione',
    'agent.referrals.table.col.status': 'Stato',
    'agent.referrals.table.col.deposited': 'Depositato',
    'agent.referrals.table.col.countsTowardRank': 'Conta',
    'agent.referrals.table.countsYes': 'Sì',
    'agent.referrals.table.countsNo': 'No',
    'user.referral.ranking.col.minDeposit': 'Deposito min.',
    'agent.referrals.table.col.referredVia': 'Referral via',
    'agent.referrals.table.loadingDirect': 'Caricamento referral diretti…',
    'agent.referrals.table.loadingIndirect': 'Caricamento referral indiretti…',
    'agent.referrals.table.emptyDirect': 'Nessun referral diretto trovato.',
    'agent.referrals.table.emptyIndirect': 'Nessun referral indiretto trovato.',
    'agent.referrals.table.showingDirect': 'Mostrati {{count}} referral diretti',
    'agent.referrals.table.showingIndirect': 'Mostrati {{count}} referral indiretti',
    'agent.referrals.table.status.active': 'Attivo',
    'agent.referrals.table.status.suspended': 'Sospeso',
    'agent.referrals.table.memberType.agent': 'Agente',
    'agent.referrals.table.memberType.user': 'Utente',
    'agent.referrals.table.via': 'via @{{username}}',
    'agent.referrals.leaderboard.title': 'Maggiori guadagni',
    'agent.referrals.leaderboard.subtitle': 'Per commissione a vita · top {{limit}}',
    'agent.referrals.leaderboard.col.position': '#',
    'agent.referrals.leaderboard.col.agent': 'Agente',
    'agent.referrals.leaderboard.col.rank': 'Grado',
    'agent.referrals.leaderboard.col.team': 'Team',
    'agent.referrals.leaderboard.col.earned': 'Guadagnato',
    'agent.referrals.leaderboard.loading': 'Caricamento classifica…',
    'agent.referrals.leaderboard.error': 'Impossibile caricare la classifica ora.',
    'agent.referrals.leaderboard.empty': 'Nessun agente attivo — invita il primo referral per entrare in classifica.',
    'agent.referrals.leaderboard.yourPosition': 'La tua posizione',
    'agent.referrals.leaderboard.badgeYou': 'Tu',
    'agent.referrals.leaderboard.lifetimeEarnings': 'Guadagni a vita',
    'agent.referrals.leaderboard.teamCounts': '{{direct}} diretti · {{indirect}} indiretti',
    'agent.referrals.leaderboard.rank.topRank': 'Grado massimo',
    'agent.referrals.leaderboard.rank.rewardEarned': 'Ricompensa ottenuta',
    'agent.referrals.leaderboard.rank.workingToward': 'In arrivo verso',
    'agent.referrals.leaderboard.rank.unranked': 'Senza grado',
    'agent.referrals.leaderboard.fallbackName': 'Agente',
  },
  ru: {
    'agent.referrals.rankExplainer':
      'Учитываются только приглашённые пользователи (не спонсируемые агенты). Каждый должен достичь минимального депозита уровня.',
    'agent.referrals.currentRank.minDeposit': '· {{amount}} мин. депозит',
    'agent.referrals.rankingFootnote':
      'Мин. депозит = завершённые депозиты каждого реферала для уровня. Награда при выполнении обоих условий.',
    'agent.referrals.tabDirect': 'Прямые рефералы ({{count}})',
    'agent.referrals.tabIndirect': 'Косвенные рефералы ({{count}})',
    'agent.referrals.tabLeaderboard': 'Рейтинг',
    'agent.referrals.tabLeaderboardCount': 'Рейтинг ({{count}})',
    'agent.referrals.link.title': 'Ваша реферальная ссылка агента',
    'agent.referrals.link.loading': 'Загрузка ссылки…',
    'agent.referrals.link.share': 'Поделиться',
    'agent.referrals.link.shareTitle': 'Присоединиться к MineMe',
    'agent.referrals.link.shareText': 'Зарегистрируйтесь по моей реферальной ссылке агента',
    'agent.referrals.link.toastUnavailable': 'Реферальная ссылка пока недоступна',
    'agent.referrals.link.toastCopied': 'Ссылка скопирована',
    'agent.referrals.link.toastCopyFailed': 'Не удалось скопировать ссылку',
    'agent.referrals.link.scheduleInstant': 'Комиссия зачисляется и доступна к выводу мгновенно.',
    'agent.referrals.link.scheduleAfterOne': 'Комиссия зачисляется и доступна к выводу через 1 день.',
    'agent.referrals.link.scheduleAfterMany': 'Комиссия зачисляется и доступна к выводу через {{days}} дн.',
    'agent.referrals.link.earningsWithIndirect': 'Вы получаете {{directPct}} комиссии со всех их инвестиций и {{indirectPct}} с инвестиций их рефералов.',
    'agent.referrals.link.earningsDirectOnly': 'Вы получаете {{directPct}} комиссии со всех их инвестиций.',
    'agent.referrals.link.intro': 'Каждый пользователь, зарегистрировавшийся по вашей ссылке, становится вашим прямым рефералом. {{earnings}}{{schedule}}',
    'agent.referrals.stats.directLabel': 'Прямые рефералы',
    'agent.referrals.stats.indirectLabel': 'Косвенные рефералы',
    'agent.referrals.stats.conversionLabel': 'Конверсия',
    'agent.referrals.stats.conversionHint': 'Активен = статус аккаунта (не факт инвестиции)',
    'agent.referrals.stats.activeTotal': '{{active}} активных / {{total}} всего',
    'agent.referrals.stats.loading': 'Загрузка…',
    'agent.referrals.stats.loadingBadge': 'Загрузка…',
    'agent.referrals.stats.noTiers': 'Уровни ранга не загружены — проверьте настройки админа.',
    'agent.referrals.stats.allTargetsMet': 'Все настроенные цели уровней достигнуты',
    'agent.referrals.stats.directTargetsNotSet': 'Цели прямых рефералов не заданы в уровнях (админ).',
    'agent.referrals.stats.indirectTargetsNotSet': 'Цели косвенных рефералов не заданы в уровнях (админ).',
    'agent.referrals.stats.directMetForTier': 'Прямое требование выполнено для {{tier}}',
    'agent.referrals.stats.directMoreToReach': 'Ещё {{remaining}} до {{tier}} ({{target}})',
    'agent.referrals.stats.indirectMetForTier': 'Косвенное требование выполнено для {{tier}}',
    'agent.referrals.stats.indirectMoreToReach': 'Ещё {{remaining}} до {{tier}} ({{target}})',
    'agent.referrals.stats.nextTierDefault': 'следующий уровень',
    'agent.referrals.filter.all': 'Все',
    'agent.referrals.filter.active': 'Активные',
    'agent.referrals.filter.suspended': 'Приостановленные',
    'agent.referrals.table.directTitle': 'Прямые рефералы',
    'agent.referrals.table.indirectTitle': 'Косвенные рефералы',
    'agent.referrals.table.indirectSubtitle': 'Команда второго уровня',
    'agent.referrals.table.searchPlaceholder': 'Поиск по имени или email',
    'agent.referrals.table.col.userId': 'ID пользователя',
    'agent.referrals.table.col.type': 'Тип',
    'agent.referrals.table.col.name': 'Имя',
    'agent.referrals.table.col.email': 'Email',
    'agent.referrals.table.col.joined': 'Дата регистрации',
    'agent.referrals.table.col.status': 'Статус',
    'agent.referrals.table.col.deposited': 'Внесено',
    'agent.referrals.table.col.countsTowardRank': 'Засчитывается',
    'agent.referrals.table.countsYes': 'Да',
    'agent.referrals.table.countsNo': 'Нет',
    'user.referral.ranking.col.minDeposit': 'Мин. депозит',
    'agent.referrals.table.col.referredVia': 'Привлечён через',
    'agent.referrals.table.loadingDirect': 'Загрузка прямых рефералов…',
    'agent.referrals.table.loadingIndirect': 'Загрузка косвенных рефералов…',
    'agent.referrals.table.emptyDirect': 'Прямые рефералы не найдены.',
    'agent.referrals.table.emptyIndirect': 'Косвенные рефералы не найдены.',
    'agent.referrals.table.showingDirect': 'Показано прямых рефералов: {{count}}',
    'agent.referrals.table.showingIndirect': 'Показано косвенных рефералов: {{count}}',
    'agent.referrals.table.status.active': 'Активен',
    'agent.referrals.table.status.suspended': 'Приостановлен',
    'agent.referrals.table.memberType.agent': 'Агент',
    'agent.referrals.table.memberType.user': 'Пользователь',
    'agent.referrals.table.via': 'через @{{username}}',
    'agent.referrals.leaderboard.title': 'Топ по доходу',
    'agent.referrals.leaderboard.subtitle': 'По комиссии за всё время · топ {{limit}}',
    'agent.referrals.leaderboard.col.position': '#',
    'agent.referrals.leaderboard.col.agent': 'Агент',
    'agent.referrals.leaderboard.col.rank': 'Ранг',
    'agent.referrals.leaderboard.col.team': 'Команда',
    'agent.referrals.leaderboard.col.earned': 'Заработано',
    'agent.referrals.leaderboard.loading': 'Загрузка рейтинга…',
    'agent.referrals.leaderboard.error': 'Сейчас не удалось загрузить рейтинг.',
    'agent.referrals.leaderboard.empty': 'Пока нет активных агентов — пригласите первого реферала.',
    'agent.referrals.leaderboard.yourPosition': 'Ваша позиция',
    'agent.referrals.leaderboard.badgeYou': 'Вы',
    'agent.referrals.leaderboard.lifetimeEarnings': 'Доход за всё время',
    'agent.referrals.leaderboard.teamCounts': '{{direct}} прямых · {{indirect}} косвенных',
    'agent.referrals.leaderboard.rank.topRank': 'Высший ранг',
    'agent.referrals.leaderboard.rank.rewardEarned': 'Награда получена',
    'agent.referrals.leaderboard.rank.workingToward': 'Стремится к',
    'agent.referrals.leaderboard.rank.unranked': 'Без ранга',
    'agent.referrals.leaderboard.fallbackName': 'Агент',
  },
  bn: {
    'agent.referrals.rankExplainer':
      'শুধু রেফার করা ব্যবহারকারী গণনায় আসে (স্পনসর এজেন্ট নয়)। প্রত্যেকে সেই স্তরের ন্যূনতম জমা পূরণ করতে হবে।',
    'agent.referrals.currentRank.minDeposit': '· {{amount}} ন্যূন. জমা',
    'agent.referrals.rankingFootnote':
      'ন্যূনতম জমা = প্রতিটি রেফার করা ব্যবহারকারীর সম্পন্ন জমা। উভয় শর্ত পূরণে পুরস্কার।',
    'agent.referrals.tabDirect': 'সরাসরি রেফারেল ({{count}})',
    'agent.referrals.tabIndirect': 'পরোক্ষ রেফারেল ({{count}})',
    'agent.referrals.tabLeaderboard': 'লিডারবোর্ড',
    'agent.referrals.tabLeaderboardCount': 'লিডারবোর্ড ({{count}})',
    'agent.referrals.link.title': 'আপনার এজেন্ট রেফারেল লিংক',
    'agent.referrals.link.loading': 'লিংক লোড হচ্ছে…',
    'agent.referrals.link.share': 'শেয়ার',
    'agent.referrals.link.shareTitle': 'MineMe-এ যোগ দিন',
    'agent.referrals.link.shareText': 'আমার এজেন্ট রেফারেল লিংক দিয়ে নিবন্ধন করুন',
    'agent.referrals.link.toastUnavailable': 'রেফারেল লিংক এখনও উপলব্ধ নয়',
    'agent.referrals.link.toastCopied': 'লিংক কপি হয়েছে',
    'agent.referrals.link.toastCopyFailed': 'লিংক কপি করা যায়নি',
    'agent.referrals.link.scheduleInstant': 'কমিশন তাৎক্ষণিক জমা হয় এবং উত্তোলনযোগ্য।',
    'agent.referrals.link.scheduleAfterOne': 'কমিশন ১ দিন পর জমা হয় এবং উত্তোলনযোগ্য।',
    'agent.referrals.link.scheduleAfterMany': 'কমিশন {{days}} দিন পর জমা হয় এবং উত্তোলনযোগ্য।',
    'agent.referrals.link.earningsWithIndirect': 'আপনি তাদের সব বিনিয়োগে {{directPct}} এবং তাদের রেফারেলের বিনিয়োগে {{indirectPct}} কমিশন পান।',
    'agent.referrals.link.earningsDirectOnly': 'আপনি তাদের সব বিনিয়োগে {{directPct}} কমিশন পান।',
    'agent.referrals.link.intro': 'আপনার লিংক দিয়ে নিবন্ধিত প্রতিটি ব্যবহারকারী সরাসরি রেফারেল হয়। {{earnings}}{{schedule}}',
    'agent.referrals.stats.directLabel': 'সরাসরি রেফারেল',
    'agent.referrals.stats.indirectLabel': 'পরোক্ষ রেফারেল',
    'agent.referrals.stats.conversionLabel': 'রূপান্তর হার',
    'agent.referrals.stats.conversionHint': 'সক্রিয় = অ্যাকাউন্টের অবস্থা (বিনিয়োগ করেছে কিনা নয়)',
    'agent.referrals.stats.activeTotal': '{{active}} সক্রিয় / {{total}} মোট',
    'agent.referrals.stats.loading': 'লোড হচ্ছে…',
    'agent.referrals.stats.loadingBadge': 'লোড হচ্ছে…',
    'agent.referrals.stats.noTiers': 'কোনো র‍্যাঙ্ক স্তর লোড হয়নি — অ্যাডমিন সেটিংস দেখুন।',
    'agent.referrals.stats.allTargetsMet': 'সব কনফিগার্ড স্তরের লক্ষ্য পূরণ হয়েছে',
    'agent.referrals.stats.directTargetsNotSet': 'সরাসরি রেফারেল লক্ষ্য স্তরে সেট নেই (অ্যাডমিন)।',
    'agent.referrals.stats.indirectTargetsNotSet': 'পরোক্ষ রেফারেল লক্ষ্য স্তরে সেট নেই (অ্যাডমিন)।',
    'agent.referrals.stats.directMetForTier': '{{tier}}-এর সরাসরি শর্ত পূরণ',
    'agent.referrals.stats.directMoreToReach': '{{tier}}-এ পৌঁছাতে আরও {{remaining}} (লক্ষ্য {{target}})',
    'agent.referrals.stats.indirectMetForTier': '{{tier}}-এর পরোক্ষ শর্ত পূরণ',
    'agent.referrals.stats.indirectMoreToReach': '{{tier}}-এ পৌঁছাতে আরও {{remaining}} (লক্ষ্য {{target}})',
    'agent.referrals.stats.nextTierDefault': 'পরবর্তী স্তর',
    'agent.referrals.filter.all': 'সব',
    'agent.referrals.filter.active': 'সক্রিয়',
    'agent.referrals.filter.suspended': 'স্থগিত',
    'agent.referrals.table.directTitle': 'সরাসরি রেফারেল',
    'agent.referrals.table.indirectTitle': 'পরোক্ষ রেফারেল',
    'agent.referrals.table.indirectSubtitle': 'দ্বিতীয় স্তরের দল',
    'agent.referrals.table.searchPlaceholder': 'ব্যবহারকারীর নাম বা ইমেইলে খুঁজুন',
    'agent.referrals.table.col.userId': 'ব্যবহারকারী ID',
    'agent.referrals.table.col.type': 'ধরন',
    'agent.referrals.table.col.name': 'নাম',
    'agent.referrals.table.col.email': 'ইমেইল',
    'agent.referrals.table.col.joined': 'যোগদানের তারিখ',
    'agent.referrals.table.col.status': 'অবস্থা',
    'agent.referrals.table.col.deposited': 'জমা হয়েছে',
    'agent.referrals.table.col.countsTowardRank': 'গণনা',
    'agent.referrals.table.countsYes': 'হ্যাঁ',
    'agent.referrals.table.countsNo': 'না',
    'user.referral.ranking.col.minDeposit': 'ন্যূনতম জমা',
    'agent.referrals.table.col.referredVia': 'রেফারেলের মাধ্যমে',
    'agent.referrals.table.loadingDirect': 'সরাসরি রেফারেল লোড হচ্ছে…',
    'agent.referrals.table.loadingIndirect': 'পরোক্ষ রেফারেল লোড হচ্ছে…',
    'agent.referrals.table.emptyDirect': 'কোনো সরাসরি রেফারেল পাওয়া যায়নি।',
    'agent.referrals.table.emptyIndirect': 'কোনো পরোক্ষ রেফারেল পাওয়া যায়নি।',
    'agent.referrals.table.showingDirect': '{{count}} সরাসরি রেফারেল দেখানো হচ্ছে',
    'agent.referrals.table.showingIndirect': '{{count}} পরোক্ষ রেফারেল দেখানো হচ্ছে',
    'agent.referrals.table.status.active': 'সক্রিয়',
    'agent.referrals.table.status.suspended': 'স্থগিত',
    'agent.referrals.table.memberType.agent': 'এজেন্ট',
    'agent.referrals.table.memberType.user': 'ব্যবহারকারী',
    'agent.referrals.table.via': '@{{username}} এর মাধ্যমে',
    'agent.referrals.leaderboard.title': 'শীর্ষ আয়',
    'agent.referrals.leaderboard.subtitle': 'আজীবন কমিশন অনুযায়ী · শীর্ষ {{limit}}',
    'agent.referrals.leaderboard.col.position': '#',
    'agent.referrals.leaderboard.col.agent': 'এজেন্ট',
    'agent.referrals.leaderboard.col.rank': 'র‍্যাঙ্ক',
    'agent.referrals.leaderboard.col.team': 'দল',
    'agent.referrals.leaderboard.col.earned': 'আয়',
    'agent.referrals.leaderboard.loading': 'লিডারবোর্ড লোড হচ্ছে…',
    'agent.referrals.leaderboard.error': 'এখন লিডারবোর্ড লোড করা যায়নি।',
    'agent.referrals.leaderboard.empty': 'এখনও কোনো সক্রিয় এজেন্ট নেই — প্রথম রেফারেল আমন্ত্রণ করুন।',
    'agent.referrals.leaderboard.yourPosition': 'আপনার অবস্থান',
    'agent.referrals.leaderboard.badgeYou': 'আপনি',
    'agent.referrals.leaderboard.lifetimeEarnings': 'আজীবন আয়',
    'agent.referrals.leaderboard.teamCounts': '{{direct}} সরাসরি · {{indirect}} পরোক্ষ',
    'agent.referrals.leaderboard.rank.topRank': 'সর্বোচ্চ র‍্যাঙ্ক',
    'agent.referrals.leaderboard.rank.rewardEarned': 'পুরস্কার অর্জিত',
    'agent.referrals.leaderboard.rank.workingToward': 'পথে',
    'agent.referrals.leaderboard.rank.unranked': 'র‍্যাঙ্কহীন',
    'agent.referrals.leaderboard.fallbackName': 'এজেন্ট',
  },
  hi: {
    'agent.referrals.rankExplainer':
      'केवल रेफ़र किए गए उपयोगकर्ता गिने जाते हैं (प्रायोजित एजेंट नहीं)। प्रत्येक को उस स्तर की न्यूनतम जमा पूरी करनी होगी।',
    'agent.referrals.currentRank.minDeposit': '· {{amount}} न्यूनतम जमा',
    'agent.referrals.rankingFootnote':
      'न्यूनतम जमा = प्रत्येक रेफ़र उपयोगकर्ता की पूर्ण जमा। दोनों शर्तें पूरी होने पर इनाम।',
    'agent.referrals.tabDirect': 'प्रत्यक्ष रेफ़रल ({{count}})',
    'agent.referrals.tabIndirect': 'अप्रत्यक्ष रेफ़रल ({{count}})',
    'agent.referrals.tabLeaderboard': 'लीडरबोर्ड',
    'agent.referrals.tabLeaderboardCount': 'लीडरबोर्ड ({{count}})',
    'agent.referrals.link.title': 'आपका एजेंट रेफ़रल लिंक',
    'agent.referrals.link.loading': 'लिंक लोड हो रहा है…',
    'agent.referrals.link.share': 'साझा करें',
    'agent.referrals.link.shareTitle': 'MineMe में शामिल हों',
    'agent.referrals.link.shareText': 'मेरे एजेंट रेफ़रल लिंक से पंजीकरण करें',
    'agent.referrals.link.toastUnavailable': 'रेफ़रल लिंक अभी उपलब्ध नहीं है',
    'agent.referrals.link.toastCopied': 'लिंक कॉपी हो गया',
    'agent.referrals.link.toastCopyFailed': 'लिंक कॉपी नहीं हो सका',
    'agent.referrals.link.scheduleInstant': 'कमीशन तुरंत जमा होता है और निकासी योग्य है।',
    'agent.referrals.link.scheduleAfterOne': 'कमीशन 1 दिन बाद जमा होता है और निकासी योग्य है।',
    'agent.referrals.link.scheduleAfterMany': 'कमीशन {{days}} दिन बाद जमा होता है और निकासी योग्य है।',
    'agent.referrals.link.earningsWithIndirect': 'आपको उनके सभी निवेश पर {{directPct}} और उनके रेफ़रल के निवेश पर {{indirectPct}} कमीशन मिलता है।',
    'agent.referrals.link.earningsDirectOnly': 'आपको उनके सभी निवेश पर {{directPct}} कमीशन मिलता है।',
    'agent.referrals.link.intro': 'आपके लिंक से पंजीकरण करने वाला हर उपयोगकर्ता आपका प्रत्यक्ष रेफ़रल बनता है। {{earnings}}{{schedule}}',
    'agent.referrals.stats.directLabel': 'प्रत्यक्ष रेफ़रल',
    'agent.referrals.stats.indirectLabel': 'अप्रत्यक्ष रेफ़रल',
    'agent.referrals.stats.conversionLabel': 'रूपांतरण दर',
    'agent.referrals.stats.conversionHint': 'सक्रिय = खाता स्थिति (निवेश किया या नहीं)',
    'agent.referrals.stats.activeTotal': '{{active}} सक्रिय / {{total}} कुल',
    'agent.referrals.stats.loading': 'लोड हो रहा है…',
    'agent.referrals.stats.loadingBadge': 'लोड हो रहा है…',
    'agent.referrals.stats.noTiers': 'कोई रैंक स्तर लोड नहीं — एडमिन सेटिंग्स देखें।',
    'agent.referrals.stats.allTargetsMet': 'सभी कॉन्फ़िगर स्तर लक्ष्य पूरे हो गए',
    'agent.referrals.stats.directTargetsNotSet': 'प्रत्यक्ष रेफ़रल लक्ष्य स्तर पर सेट नहीं (एडमिन)।',
    'agent.referrals.stats.indirectTargetsNotSet': 'अप्रत्यक्ष रेफ़रल लक्ष्य स्तर पर सेट नहीं (एडमिन)।',
    'agent.referrals.stats.directMetForTier': '{{tier}} के लिए प्रत्यक्ष शर्त पूरी',
    'agent.referrals.stats.directMoreToReach': '{{tier}} तक {{remaining}} और चाहिए (लक्ष्य {{target}})',
    'agent.referrals.stats.indirectMetForTier': '{{tier}} के लिए अप्रत्यक्ष शर्त पूरी',
    'agent.referrals.stats.indirectMoreToReach': '{{tier}} तक {{remaining}} और चाहिए (लक्ष्य {{target}})',
    'agent.referrals.stats.nextTierDefault': 'अगला स्तर',
    'agent.referrals.filter.all': 'सभी',
    'agent.referrals.filter.active': 'सक्रिय',
    'agent.referrals.filter.suspended': 'निलंबित',
    'agent.referrals.table.directTitle': 'प्रत्यक्ष रेफ़रल',
    'agent.referrals.table.indirectTitle': 'अप्रत्यक्ष रेफ़रल',
    'agent.referrals.table.indirectSubtitle': 'दूसरे स्तर की टीम',
    'agent.referrals.table.searchPlaceholder': 'उपयोगकर्ता नाम या ईमेल से खोजें',
    'agent.referrals.table.col.userId': 'उपयोगकर्ता ID',
    'agent.referrals.table.col.type': 'प्रकार',
    'agent.referrals.table.col.name': 'नाम',
    'agent.referrals.table.col.email': 'ईमेल',
    'agent.referrals.table.col.joined': 'शामिल होने की तारीख',
    'agent.referrals.table.col.status': 'स्थिति',
    'agent.referrals.table.col.deposited': 'जमा',
    'agent.referrals.table.col.countsTowardRank': 'गिनती',
    'agent.referrals.table.countsYes': 'हाँ',
    'agent.referrals.table.countsNo': 'नहीं',
    'user.referral.ranking.col.minDeposit': 'न्यूनतम जमा',
    'agent.referrals.table.col.referredVia': 'रेफ़र किया गया',
    'agent.referrals.table.loadingDirect': 'प्रत्यक्ष रेफ़रल लोड हो रहे हैं…',
    'agent.referrals.table.loadingIndirect': 'अप्रत्यक्ष रेफ़रल लोड हो रहे हैं…',
    'agent.referrals.table.emptyDirect': 'कोई प्रत्यक्ष रेफ़रल नहीं मिला।',
    'agent.referrals.table.emptyIndirect': 'कोई अप्रत्यक्ष रेफ़रल नहीं मिला।',
    'agent.referrals.table.showingDirect': '{{count}} प्रत्यक्ष रेफ़रल दिखाए जा रहे हैं',
    'agent.referrals.table.showingIndirect': '{{count}} अप्रत्यक्ष रेफ़रल दिखाए जा रहे हैं',
    'agent.referrals.table.status.active': 'सक्रिय',
    'agent.referrals.table.status.suspended': 'निलंबित',
    'agent.referrals.table.memberType.agent': 'एजेंट',
    'agent.referrals.table.memberType.user': 'उपयोगकर्ता',
    'agent.referrals.table.via': '@{{username}} के माध्यम से',
    'agent.referrals.leaderboard.title': 'शीर्ष कमाई',
    'agent.referrals.leaderboard.subtitle': 'जीवनभर कमीशन के अनुसार · शीर्ष {{limit}}',
    'agent.referrals.leaderboard.col.position': '#',
    'agent.referrals.leaderboard.col.agent': 'एजेंट',
    'agent.referrals.leaderboard.col.rank': 'रैंक',
    'agent.referrals.leaderboard.col.team': 'टीम',
    'agent.referrals.leaderboard.col.earned': 'कमाई',
    'agent.referrals.leaderboard.loading': 'लीडरबोर्ड लोड हो रहा है…',
    'agent.referrals.leaderboard.error': 'अभी लीडरबोर्ड लोड नहीं हो सका।',
    'agent.referrals.leaderboard.empty': 'अभी कोई सक्रिय एजेंट नहीं — पहला रेफ़रल आमंत्रित करें।',
    'agent.referrals.leaderboard.yourPosition': 'आपकी स्थिति',
    'agent.referrals.leaderboard.badgeYou': 'आप',
    'agent.referrals.leaderboard.lifetimeEarnings': 'जीवनभर कमाई',
    'agent.referrals.leaderboard.teamCounts': '{{direct}} प्रत्यक्ष · {{indirect}} अप्रत्यक्ष',
    'agent.referrals.leaderboard.rank.topRank': 'शीर्ष रैंक',
    'agent.referrals.leaderboard.rank.rewardEarned': 'इनाम प्राप्त',
    'agent.referrals.leaderboard.rank.workingToward': 'की ओर',
    'agent.referrals.leaderboard.rank.unranked': 'बिना रैंक',
    'agent.referrals.leaderboard.fallbackName': 'एजेंट',
  },
};
